import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms'

@Component({
  selector: 'app-filter-input',
  templateUrl: './filter-input.component.html',
  styleUrls: ['./filter-input.component.css']
})
export class FilterInputComponent implements OnInit {
  @Output() changeEvent = new EventEmitter<string>()
  valueControl = new FormControl();

  constructor() { }

  ngOnInit() {
    this.valueControl.valueChanges
      .map((v) => v.trim())
      .debounceTime(1000)
      .distinctUntilChanged()
      .subscribe((txt) => this.changeEvent.emit(txt))
  }

}



// WEBPACK FOOTER //
// ./src/app/filter-input/filter-input.component.ts